module.exports = __webpack_public_path__ + "assets/img/Apple iPhone 12 Black.fbf3e785.png";